import type { AttributePlugin } from '../../../engine/types'
import { pathToObj } from '../../../utils/paths'
import { modifyCasing } from '../../../utils/text'
import { findClosestScoped } from '../../../utils/dom'

export const Signals: AttributePlugin = {
  type: 'attribute',
  name: 'signals',
  isExpr: true,
  onLoad: ({ el, key, mods, rx, merge }) => {
    const ifMissing = mods.has('ifmissing')
    const toMerge = rx()
    const args = { ifMissing }

    if (mods.has('scoped')) {
      const scope = findClosestScoped(el)
      merge(scope ? { [scope]: toMerge } : toMerge, args)
    } else if (key !== '') {
      merge(pathToObj({}, { [modifyCasing(key, mods)]: toMerge }), args)
    } else {
      merge(toMerge, args)
    }
  },
}
